import CancelledBookings from '@commons/bookings/cancelled'
import React from 'react'

const UserCancelledBookings = ({ user }) => {
  return <CancelledBookings user={user} />
}

export default UserCancelledBookings
